export const getApiUrl = () => {
  const isLocal = window.location.host.indexOf('localhost') !== -1
  return isLocal
    ? 'http://localhost:8002/api'
    : 'https://website.magno-it.nl/api'
}

const config = {
  baseUrl: getApiUrl(),
}

export const getSessionId = (): string => {
  return localStorage.getItem('MagnoToken') || ''
}

export const authedGet = async (path: string) => {
  const result = await fetch(`${config.baseUrl}/${path}`, {
    method: 'GET',
    headers: {
      'X-authenticated': getSessionId(),
    },
  })
  return result
}

const authedMutate = async (
  method: string,
  path: string,
  body: any,
  headers: any
) => {
  const _headers = {
    'X-authenticated': getSessionId(),
    ...headers,
  }
  const result = await fetch(`${config.baseUrl}/${path}`, {
    method,
    headers: _headers,
    body: body,
  })
  return result
}

export const authedPost = async (path: string, body: any, headers = {}) => {
  return await authedMutate('POST', path, body, headers)
}
